<script setup>
// Envio de teste pela caixa de e-mail escolhida para o e-mail de quem edita.
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useAlert } from 'dashboard/composables';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import API from 'dashboard/api/marketingEmailTemplates';

const props = defineProps({
  templateId: { type: [String, Number], required: true },
  beforeSend: { type: Function, default: async () => {} },
});
const { t } = useI18n();
const store = useStore();
const dialog = ref(null);
const inboxId = ref(null);
const sending = ref(false);
const inboxes = computed(() => store.getters['inboxes/getEmailInboxes'] || []);

const open = async () => {
  store.dispatch('inboxes/get');
  await props.beforeSend();
  inboxId.value = inboxId.value || inboxes.value[0]?.id || null;
  dialog.value?.open();
};
const send = async () => {
  if (!inboxId.value) return;
  sending.value = true;
  try {
    const { data } = await API.sendTest(props.templateId, inboxId.value);
    useAlert(t('EMAIL_TEMPLATES.BUILDER.TEST.SENT', { email: data.sent_to }));
    dialog.value?.close();
  } catch (error) {
    useAlert(error?.response?.data?.error || t('EMAIL_TEMPLATES.SAVE_ERROR'));
  } finally {
    sending.value = false;
  }
};
defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialog"
    type="edit"
    :title="t('EMAIL_TEMPLATES.BUILDER.TEST.TITLE')"
    :description="t('EMAIL_TEMPLATES.BUILDER.TEST.DESCRIPTION')"
    :confirm-button-label="t('EMAIL_TEMPLATES.BUILDER.TEST.SEND')"
    :is-loading="sending"
    :disable-confirm-button="!inboxId"
    @confirm="send"
  >
    <p v-if="!inboxes.length" class="text-sm text-n-amber-11">
      {{ t('EMAIL_TEMPLATES.BUILDER.TEST.NO_INBOX') }}
    </p>
    <select
      v-else
      v-model="inboxId"
      class="w-full rounded-lg border border-n-weak bg-n-solid-1 px-2.5 py-1.5 text-sm"
    >
      <option v-for="ib in inboxes" :key="ib.id" :value="ib.id">
        {{ ib.name }}
      </option>
    </select>
  </Dialog>
</template>
